namespace app.gestao {
    "use strict";
    import ITranslatePartialLoaderProvider = angular.translate.ITranslatePartialLoaderProvider;
    import IStateProvider = angular.ui.IStateProvider;
    import DashboardService = app.support.dashboards.DashboardService;

    /** @ngInject **/
    function run (dashboardService: DashboardService,
            msNavigationService: any,
            $rootScope: ng.IRootScopeService){
        
        function setUpDashboard() {
            dashboardService.hasDashboards().then(hasDashboards => {
                if (hasDashboards)
                    // Navigation
                    msNavigationService.saveItem("gestao", {
                        title : "GESTÃO",
                        translation: "GESTAO.GESTAO",
                        group : true,
                        weight: 1
                    });
                    msNavigationService.sort();
            });    
        }
        
        $rootScope.$on("user:logged", () => {
            setUpDashboard();
        });
        
        setUpDashboard();
        
        $rootScope.$on("user:exited", () => {
            let navigation = msNavigationService.getNavigation();
            _.remove(<Array<any>>navigation, (nav) => nav._id === "gestao");
        });
        
    }
    /** @ngInject **/
    function config($translatePartialLoaderProvider: ITranslatePartialLoaderProvider,
                     $stateProvider: IStateProvider,
                     msNavigationServiceProvider: any) {

        $translatePartialLoaderProvider.addPart("app/main/gestao");

        $stateProvider
            .state("app.gestao", {
                abstract: true,
                url: "/gestao",
                parent: "app.autenticado",
            });
    }

    angular
        .module("app.gestao", ["app.autenticado"])
        .config(config)
        .run(run);
}